import { DrawerLayout } from '@/components/layouts/DrawerLayout';
import { FormProvider, useForm, useFieldArray, useFormContext } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup"
import { FormInput } from '@/components/forms/FormInput.jsx';
import { Stack, Button, Box } from '@mui/joy';
import { FormButtons } from '@/components/FormButtons.jsx';
import { useCreateRecipesImportMutation } from '../api.js';
import Add from '@mui/icons-material/Add';
import { MIN_URLS, MAX_URLS, newItem, newRecipesImport, recipesImportSchema } from '../schema';
import { RemoveFormElementButton } from '@/components/RemoveFormElementButton';
import { useNavigate, useParams } from 'react-router-dom';

export function CreateRecipesImportPage() {
  const { householdId } = useParams();
  const navigate = useNavigate();

  const form = useForm({
    defaultValues: newRecipesImport(),
    resolver: yupResolver(recipesImportSchema)
  });

  const [createImport, result] = useCreateRecipesImportMutation();

  async function onSubmit(data) {
    const result = await createImport({ householdId, data });
    if (!result.error) {
      navigate(`/h/${householdId}/recipes/imports/${result.data.id}`);
    }
  }

  return  (
    <DrawerLayout title="Import Recipes">
      <FormProvider {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)}>
          <Box sx={{ pt: 2, pb: 3 }}>                      
            <ItemsForm />
          </Box>
          <FormButtons isSaving={result.isLoading} />
        </form>
      </FormProvider>
    </DrawerLayout>
  );
}

function ItemsForm() {
  const { fields, append, remove, replace } = useFieldArray({ name: 'items' });
  const { watch } = useFormContext();
  const items = watch('items');

  function handlePaste(event, index) {            
    const text = event.clipboardData.getData('text/plain');

    if (text.includes("\n")) {
      event.preventDefault();
      const urls = text.split('\n').filter(url => url.trim() !== '');      

      replace(
        items.slice(0, index).concat(
          urls.map(url => ({ url: url.trim() }))
        ).concat(
          items.slice(index + 1)
        )
      );
    } 
  }

  return (
    <Stack spacing={2}>
      {fields.map((field, index) => (
        <Stack key={field.id} direction="row" alignItems="start" gap={1}>             
          <FormInput name={`items.${index}.url`} placeholder="Enter single URL or paste multiple URLs" sx={{ flexGrow: 1 }} onPaste={(e) => handlePaste(e, index)} />
          {fields.length > MIN_URLS && <RemoveFormElementButton onClick={() => remove(index)} />}
        </Stack>
      ))}
      {fields.length < MAX_URLS && <Box>
        <Button startDecorator={<Add />} variant="outlined" onClick={() => append(newItem())}>Add URL</Button>
      </Box>}      
    </Stack>           
  );
}
